/**
 * @typedef {Object} Qm
 * @property {Number} id ID
 * @property {Number} quiz_type １：3択
 * @property {Number} quiz_selections_masters_group_id 選択肢グループマスターID
 * @property {string} quiz_text 問題文
 * @property {Number} hint_masters_id ヒントマスターID
 * @property {string} hint_url ヒントのURL
 * @property {string} correct_text 正解時のテキスト
 * @property {string} question_image 問題イメージURL
 * @property {string} answer_image 回答イメージURL
 * @property {Number} point ポイント
 * @property {Number} disable_flag 非表示フラグ
 * @property {Number} limited_flag 期間限定フラグ
 * @property {string} start_datetime 公開開始日時
 * @property {string} end_datetime 更改終了日時
 * @property {string} description 備考
 */

/**
 * @typedef {Object} Qsm
 * @property {Number} id ID
 * @property {Number} group_id アンケートのマスターID
 * @property {Number} number 番号順
 * @property {string} selection 選択肢
 * @property {Number} correct_flag 正解フラグ
 */

/**
 * @typedef {Object} Uq
 * @property {Number} id ID
 * @property {Number} user_masters_id ユーザーマスターID
 * @property {Number} quiz_masters_id クイズマスターID
 * @property {Number} hint_view_count ヒントを見た回数
 * @property {Number} correct_flag 正誤判定
 */

/**
 * @typedef {Object} Information
 * @property {Qm[]} qm_list
 * @property {Qsm[][]} qsm_lists
 * @property {Uq[]} uq_list
 * @property {Number} point
 */

/**
 * @typedef {Object} CorrectInformation
 * @property {Number} qm_id
 * @property {String} quiz_text 問題文テキスト
 * @property {String} hint_url ヒントURL
 * @property {String} correct_text 答えテキスト
 * @property {Number} point ポイント
 * @property {String} selection 答え
 */

/**
 * @typedef {Object} IncorrectInformation
 * @property {Number} qm_id
 * @property {String} hint_url ヒントURL
 */

import * as LoadingWaitTypes from '@/constants/LoadingWaitTypes'

/**
 * @typedef {Object} State
 * @property {Information} information
 * @property {Number} quiz_list_view クイズリストの表示物を示す 1:チャレンジ 2:クリア
 * @property {boolean} is_login
 * @property {CorrectInformation} result_correct_information
 * @property {IncorrectInformation} result_incorrect_information
 * @property {Number} page_number 現在のページ番号
 * @property {boolean[]} loading_waits
 */

const state = {
  information: {
    qm_list: {},
    qsm_lists: {},
    uq_list: {},
    point: 0
  },
  quiz_list_view: 1,
  is_login: false,
  result_correct_information: null,
  result_incorrect_information: null,
  page_number: 1,
  loading_waits: {
    [LoadingWaitTypes.INITIALIZE]: true
  }
}

export default state
